export const capitalize = (word) =>
  `${word[0].toUpperCase()}${word.slice(1, word.length)}`;
